<script setup>
import { onMounted, ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';

import instagramClient from 'dashboard/api/channel/instagramClient';

import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { redirectToCanonicalMetaHost } from 'dashboard/helper/canonicalMetaAuth';

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

onMounted(async () => {
  try {
    await redirectToCanonicalMetaHost();
  } catch (_error) {
    useAlert(t('INBOX_MGMT.ADD.INSTAGRAM.ERROR_AUTH'));
  }
});

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await instagramClient.generateAuthorization();

    const {
      data: { url },
    } = response;

    window.location.href = url;
  } catch (error) {
    useAlert(t('INBOX_MGMT.ADD.INSTAGRAM.ERROR_AUTH'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired class="mx-6" @reauthorize="requestAuthorization" />
</template>
